import { render, staticRenderFns } from "./FundingDashboard.vue?vue&type=template&id=082a0260&scoped=true&"
import script from "./FundingDashboard.vue?vue&type=script&lang=js&"
export * from "./FundingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FundingDashboard.vue?vue&type=style&index=0&id=082a0260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a0260",
  null
  
)

export default component.exports